import { isProd } from "../../util/functions";
const API_VERSION = "/api/v1";
const MICROSERVICE_NAME = "/book";
/**
 * @typedef {{pageIndex:number,pageSize:number,orderBy:'createdDate'|'title'|'updatedDate'}} FetchMemoryDto
 */
const baseURL = () => {
  if (isProd) {
    return `https://memory.api.mystoriesmatter.com${API_VERSION}`;
  }

  return `https://qa-memory.api.mystoriesmatter.com${API_VERSION}`;
};

const nestBaseURL = isProd
  ? "https://nest.mystoriesmatter.com"
  : "https://nest-qa.mystoriesmatter.com";

export const getBookListUrl = `${baseURL()}${MICROSERVICE_NAME}`;

export const getBookUrl = `${nestBaseURL}${MICROSERVICE_NAME}`;

export const getBookMemoriesUrl = (bookId) =>
  bookId
    ? `${nestBaseURL}${MICROSERVICE_NAME}/memories?bookId=${bookId}`
    : `${nestBaseURL}${MICROSERVICE_NAME}/memories`;

export const getCreateBookUrl = `${nestBaseURL}${MICROSERVICE_NAME}`;

export const getCreateSubmissionUrl = `${nestBaseURL}/submissions`;

export const getMemoriesOfABookUrl = (bookID) =>
  `${baseURL()}${MICROSERVICE_NAME}/${bookID}`;

export const getUpdateBookUrl = (bookID) =>
  `${nestBaseURL}${MICROSERVICE_NAME}/${bookID}`;

/**
 *
 * @param {number} pageIndex
 */
export const getSubmissionUrl = (pageIndex) =>
  `${nestBaseURL}/book/list?pageSize=10&pageIndex=${pageIndex}`;

export const getOrderMemoriesUrl = ({
  orderID,
  pageIndex,
  orderBy = "recent",
}) =>
  `${baseURL()}/admin/book/memories/${orderID}?pageSize=10&pageIndex=${pageIndex}&orderBy=${orderBy}`;

export const downloadBookSubmissionUrl = (orderID) => {
  return `${baseURL()}/admin/book/download/${orderID}`;
};

export const downloadBookUrl = (bookID) =>
  `${baseURL()}/book/download/${bookID}`;
